<div class="mb-3 position-relative" [formGroup]="group">
    <label [attr.for]="id">
        <ng-content select="[label]"></ng-content>
        <span class="text-danger" *ngIf="requiredMsg"> *</span>
    </label>
    <dp-date-picker
        #dayPicker
        [id]="id"
        [formControlName]="controlName"
        [placeholder]="placeholder || format"
        [config]="dayPickerConfig"
    >
    </dp-date-picker>
    <i class="fa fa-calendar" (click)="open($event)" aria-hidden="true"></i>
</div>